import { EmptyState } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';

interface DiscountsQueryEmptyStateProps {
  searchTerm: string;
  isVisible: boolean;
}

const DiscountsQueryEmptyState: React.FC<DiscountsQueryEmptyStateProps> = ({
  searchTerm,
  isVisible,
}) =>
  isVisible ? (
    searchTerm ? (
      <EmptyState
        title="No discounts found"
        subtitle={
          <Typography variant="body2" component={'div'}>
            No results found for search term{' '}
            <Typography variant="subtitle2">{searchTerm}</Typography>
          </Typography>
        }
      />
    ) : (
      <EmptyState
        title="No discounts available"
        subtitle={
          <Typography variant="body2" component={'div'}>
            Discounts have not been added by your manager or admin yet. Once
            they are set up, you will be able to insert them into your
            proposals.
          </Typography>
        }
      />
    )
  ) : null;

export default DiscountsQueryEmptyState;
